import React, {Component} from 'react';
import {Redirect, withRouter} from 'react-router-dom';

import Layout from '../../components/Layout'
import RosterProfile from '../../pages/RosterDetails/RosterProfile'
import Loading from '../../components/Base/Loading'


class RosterProfileContainer extends Component {
	_isMounted = false

	constructor(props) {
		super(props);
		this.rosterID = this.props.match.params.roster;

		this.id = this.props.match.params.profile;
		this.state = {
			width: 0,
			height: 0,
			loading: false,
			data: null
		};

	}

	componentDidMount() {
		this._isMounted = true
		this.listener = this.fetchProfileListener()
		this.rosterListener = this.fetchRosterListener()

	}

	fetchProfileListener = () => {
		return this.props.firebase.student(this.id).onSnapshot(snapshot => {
			let result = {id: snapshot.id, ...snapshot.data()};
			this.setState({data: {...result, leaves: [], wave: []}})

			this.handleSelectStudent(result)
		})
	};

	fetchRosterListener = () => {
		const {history} = this.props;
		return this.props.firebase.roster(this.rosterID).onSnapshot(snapshot => {
				let roster = {id: snapshot.id, ...snapshot.data()};
				if(!roster.students_uid.includes(this.id)){

					history.push(`/app/roster/${this.rosterID}`)
				}
				this.setState({roster, loading: false})

				// this.fetchRoster(roster)

			}
		)
	};

	handleSelectStudent = async (details) => {
		try {
			let studentRef = this.props.firebase.student(details.id);
			let leavesRef = await this.props.firebase.leaves().where('student_uid', '==', details.id).orderBy('start_date', 'asc').get();
			let leaveResult = [];
			let waveResult = [];
			let waveRef = await studentRef.collection('wave_history').orderBy('post_time').get();
			leavesRef.docs.forEach(doc => leaveResult.push({id: doc.id, ...doc.data()}));
			waveRef.docs.forEach(doc => waveResult.push({id: doc.id, ...doc.data()}));
			for(let i in waveResult){
				try {
					if(waveResult[i].creator_uid.length === 7){
						let studentRef = await this.props.firebase.student(waveResult[i].creator_uid).get()
						waveResult[i].creator = {id: studentRef.id, ...studentRef.data()}
					} else {
						let studentRef = await this.props.firebase.faculty(waveResult[i].creator_uid).get()
						waveResult[i].creator = {id: studentRef.id, ...studentRef.data()}
					}
				} catch (e) {
					console.log('error fetching wave creator', e)
				}
			}
			details.leaves = leaveResult;
			details.wave = waveResult;

			if(this._isMounted === true) this.setState({data: details})
		} catch (err) {
			console.log('failed to fetch student: ', err)
		}


	};

	componentWillUnmount() {
		this.listener()
		this.rosterListener()
		this._isMounted = false
	}

	render() {
		const {data, roster, loading} = this.state;
		const {profile, isFaculty} = this.props;
		if(profile !== null && !isFaculty){
			if(this.id.length > 4 && !profile.is_prefect){
				return <Redirect to={'/app/home'}/>
			}
		}
		return (
			<Layout {...this.props} noSideBar noFooter>
				{data === null ? <Loading/> :
					<RosterProfile {...this.props} data={data} roster={roster} loading={loading}/>}
			</Layout>
		);
	}
}


export default withRouter(RosterProfileContainer);
